import NewsCardPage from './NewsCardPage';
export default NewsCardPage;
